// Protect saved goal gifts at the existing donation-bag checkout handoff.
if (!window.VGMGoalCheckoutGuard) {
  window.VGMGoalCheckoutGuard = true;
  let busy = false, allowOnce = false;
  const root = window.Shopify?.routes?.root || '/';
  const copy = JSON.parse(document.querySelector('[data-vgm-goal-checkout-i18n]')?.textContent || '{}');
  async function validate() {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(copy.error);
    const cart = await response.json();
    const items = cart.items.filter(item => item.properties?._vgm_project_id).map(item => ({ key: item.key, productId: item.product_id, variantId: item.variant_id, projectId: item.properties._vgm_project_id }));
    if (!items.length) return true;
    const result = await fetch(`${root}apps/vgm-goals/validate`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }), cache: 'no-store' });
    if (!result.ok) throw new Error(copy.error);
    const data = await result.json();
    if (!data.valid) throw new Error(copy.changed);
    return true;
  }
  async function guard(event, target, proceed) {
    if (allowOnce) { allowOnce = false; return; }
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy) return;
    busy = true; target.setAttribute('aria-busy', 'true');
    const status = document.querySelector('[data-vgm-goal-checkout-status]');
    try { await validate(); if (status) status.textContent = ''; proceed(); }
    catch (error) { if (status) { status.hidden = false; status.textContent = error.message || copy.error; status.focus(); } window.dispatchEvent(new CustomEvent('vgm:cart:open', { detail: { source: 'vgm-goal-checkout' } })); }
    finally { busy = false; target.removeAttribute('aria-busy'); }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-sgh-checkout]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey) return;
    void guard(event, link, () => window.location.assign(link.href));
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout') return;
    void guard(event, event.submitter, () => { allowOnce = true; event.target.requestSubmit(event.submitter); });
  }, true);
}
